import React from 'react';
import Icon from '../../../components/AppIcon';

const StepIndicator = ({ currentStep, steps }) => {
  return (
    <div className="w-full mb-8 md:mb-10 lg:mb-12">
      <div className="flex items-center justify-between relative">
        {/* Progress Line */}
        <div className="absolute top-6 left-0 right-0 h-0.5 bg-muted -z-10">
          <div 
            className="h-full bg-primary transition-all duration-500 ease-out"
            style={{ width: `${((currentStep - 1) / (steps?.length - 1)) * 100}%` }}
          />
        </div>

        {/* Step Circles */}
        {steps?.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          const isPending = stepNumber > currentStep;

          return (
            <div key={step?.id} className="flex flex-col items-center flex-1">
              <div
                className={`
                  w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full flex items-center justify-center
                  transition-all duration-300 ease-out mb-2 md:mb-3 lg:mb-4
                  ${isCompleted ? 'bg-primary text-primary-foreground shadow-warm' : ''}
                  ${isCurrent ? 'bg-accent text-accent-foreground shadow-warm-md scale-110' : ''}
                  ${isPending ? 'bg-muted text-muted-foreground' : ''}
                `}
              >
                {isCompleted ? (
                  <Icon name="Check" size={20} />
                ) : (
                  <span className="text-base md:text-lg lg:text-xl font-semibold">{stepNumber}</span>
                )}
              </div>
              <div className="text-center">
                <p className={`
                  text-xs md:text-sm lg:text-base font-medium transition-colors duration-300
                  ${isCurrent ? 'text-foreground' : 'text-muted-foreground'}
                `}>
                  {step?.title}
                </p>
                <p className="text-xs text-muted-foreground mt-1 hidden md:block">
                  {step?.subtitle}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;